/* eslint-disable */
import { pickBy } from 'lodash';
import moment from 'moment';

export const hasResolvePermissions = user =>
  user.isPrimaryBankAdmin || user.isSuperAdmin || user.isBankAdmin;

export const hasAcknowledgePermissions = user =>
  user.isPrimaryBankAdmin || user.isSuperAdmin || user.isBankAdmin;

export const createAccountArray = accounts =>
  accounts.map(a => ({
    value: `${a.id}`,
    label: a.businessName,
  })) || [];

const createSummaryRow = (fn, counts) => {
  const s = fn(counts);
  return {
    ...s,
    account: counts.businessName,
    total: s.passed + s.needsReview + s.failed,
  };
};

const createSummaryTableData = fn => data => {
  const countsArray = data?.counts || [];
  return countsArray.map(c => createSummaryRow(fn, c));
};

const createSummaryChartData = fn => data => {
  if (!data) {
    return null;
  }
  const obj = createSummaryRow(fn, data.countsTotals);
  return [
    obj.passed / obj.total,
    obj.needsReview / obj.total,
    obj.failed / obj.total,
  ];
};

const summarizeBeforeResolve = counts => ({
  passed: counts.passed,
  needsReview: counts.needsReviewResolved + counts.needsReviewUnresolved,
  failed: counts.failedResolved + counts.failedUnresolved,
});

const summarizeAfterResolve = counts => ({
  passed: counts.passed + counts.failedResolved + counts.needsReviewResolved,
  needsReview: counts.needsReviewUnresolved,
  failed: counts.failedUnresolved,
});

export const createChartData1 = createSummaryChartData(summarizeBeforeResolve);
export const createChartData2 = createSummaryChartData(summarizeAfterResolve);
export const createDashboardSummaryData = createSummaryTableData(
  summarizeBeforeResolve
);
export const createOverviewSummaryData = createSummaryTableData(
  summarizeAfterResolve
);

export const processTableDataForExport = rows => {
  const blacklist = [
    'supplementalInformation',
    'flag',
    'flagClassName',
    'statusClassName',
    'location',
    'user',
  ];
  return rows.map(row => {
    const d = pickBy(row, (v, k) => !blacklist.includes(k));
    d.date = moment(new Date(d.date)).format('MM/DD/YYYY hh:mm:ss A');
    d.backgroundAssessmentType = d.backgroundAssessmentType.type;
    d.backgroundAssessmentTypeResult = d.backgroundAssessmentTypeResult.result;
    d.account = d.account.businessName;
    return d;
  });
};
